export const createManuallyResolvedPromise = () => {

    const getCallResolve = (resolve: any) => () => resolve();
    let callResolve: () => void;

    const promise = new Promise((resolve) => {
        callResolve = getCallResolve(resolve);
    });

    return Object.assign(
        promise,
        { resolve: callResolve }
    );
};
